module.exports = __webpack_public_path__ + "static/media/background-client-table-small.009d2ab0.jpg";